import React from 'react';

import { ReactDataTable } from '@metarouter-private/mr-mui';

import useEventDebuggerTableProps from './useEventDebuggerTableProps';

export default function EventDebuggerTable() {
  const eventDebuggerTable = useEventDebuggerTableProps();
  return <ReactDataTable {...eventDebuggerTable} />;
}
